import React, { useEffect, useState } from 'react';
import style from './BookList.module.css';

const BookList = ({ activity, message }) => {
  const [inputValue, setInputValue] = useState('');
  const [booksSummary, setBooksSummary] = useState([]);
  const [filteredBooksSummary, setFilteredBooksSummary] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBook, setSelectedBook] = useState(null);
  const [loading, setLoading] = useState(false); 
  const itemsPerPage = 150;

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

  useEffect(() => {
    setLoading(true); 
    const bookStats = {};
    activity.forEach((user) => {
      user.booksWithPlayback.forEach((book) => {
        if (!bookStats[book.bookName]) {
          bookStats[book.bookName] = { count: 0, totalPlaybackTime: 0, users: [] };
        }
        bookStats[book.bookName].count += 1;
        bookStats[book.bookName].totalPlaybackTime += book.lastPlaybackTime;
        bookStats[book.bookName].users.push({ phone: user.phone, playbackTime: book.lastPlaybackTime });
      });
    });

    const summary = Object.entries(bookStats).map(([bookName, stats]) => ({
      bookName,
      count: stats.count,
      totalPlaybackTime: stats.totalPlaybackTime,
      users: stats.users,
    }));

    setBooksSummary(summary);
    setFilteredBooksSummary(summary);
    setLoading(false);
  }, [activity]);

  const handleSearch = () => {
    setLoading(true);
    if (inputValue.length > 0) {
      const filtered = booksSummary.filter((book) =>
        book.bookName.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredBooksSummary(filtered);
    } else {
      setFilteredBooksSummary(booksSummary);
    }
    setCurrentPage(1);
    setLoading(false);
  };

  const totalPages = Math.ceil(filteredBooksSummary.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBooksSummary.slice(indexOfFirstItem, indexOfLastItem);

  const handleBookClick = (bookName) => {
    const selected = filteredBooksSummary.find((book) => book.bookName === bookName);
    setSelectedBook(selected === selectedBook ? null : selected);
  };

  const exportToCSV = () => {
    const headers = ["Book Name", "Number of Users", "Total Playback Time (H:M:S)", "User Phone", "Playback Time (H:M:S)"];
    
    let csvContent = "data:text/csv;charset=utf-8," + headers.join(",") + "\n";
  
    filteredBooksSummary.forEach((book) => {
      csvContent += `"${book.bookName.replace(/"/g, '""')}",${book.count},${formatTime(book.totalPlaybackTime)},,\n`;
      book.users.forEach((user) => {
        csvContent += `,,,"${user.phone}",${formatTime(user.playbackTime)}\n`;
      });
    });
  
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "books_activity.csv");
    link.click();
  };

  return (
    <>
      {loading && (
        <div className="d-flex justify-content-center align-items-center my-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {!loading && (
        <div>
          <div className="form-group position-relative">
            <label htmlFor="search">Search:</label>
            <div className="d-flex">
              <input
                type="text"
                className="form-control m-3"
                id="search"
                placeholder="Type to search..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <button onClick={handleSearch} className="btn btn-secondary m-3">
                Search
              </button>
              <button onClick={exportToCSV} className="btn btn-secondary m-3">
                Export to CSV
              </button>
            </div>
          </div>
          <div className={style.subdiv}>
            {message && <p>{message}</p>}
            {currentItems.length > 0 ? (
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Book Name</th>
                      <th>Number of Users</th>
                      <th>Total Playback Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((book, index) => (
                      <tr key={index}>
                        <td>
                          <span
                            onClick={() => handleBookClick(book.bookName)}
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                          >
                            {book.bookName}
                          </span>
                          {selectedBook && selectedBook.bookName === book.bookName && (
                            <div className="dropdown">
                              <ul>
                                {book.users.map((user, index) => (
                                  <li key={index}>
                                    <strong>Phone:</strong> {user.phone} - <strong>Playback Time:</strong> {formatTime(user.playbackTime)}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </td>
                        <td>{book.count}</td>
                        <td>{formatTime(book.totalPlaybackTime)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="container">
                  <div className="pagination">
                    <button onClick={prevPage} disabled={currentPage === 1}>
                      Previous
                    </button>
                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                      >
                        {index + 1}
                      </button>
                    ))}
                    <button onClick={nextPage} disabled={currentPage === totalPages}>
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <p>No books found.</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BookList;
